import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const questions = [
  ["How can I track my order?", "When an order is dispatched, we send a confirmation email with any available tracking link. If it has not arrived, check your spam folder or contact us."],
  ["Can I change or cancel an order?", "Contact us as soon as possible. We will help if packing has not started, but personalised, perishable or dispatched orders may not be changeable."],
  ["Do you include prices in gifts?", "Gift parcels do not normally include a printed price. Your order confirmation and payment record are sent to the purchaser."],
  ["Can I add a gift message?", "Where available, enter your message during checkout. Personalised product labels must be reviewed carefully before the order is submitted."],
  ["What if an item is unavailable?", "Occasionally we may substitute an item with one of equal or greater value and similar character, or contact you with another option."],
  ["Which items cannot be returned?", "Perishable, personalised, opened hygiene-sensitive and age-restricted items may be excluded unless faulty. Read the Returns Policy for details."],
  ["How should food gifts be stored?", "Follow the label on each product. Refrigerate chilled items promptly and check best-before or use-by dates when the parcel arrives."],
  ["How do I contact failblossom?", "Email level@failblossom.lifestyle and include your order number when your question relates to an existing purchase."],
];

function Faqs() {
  return (
    <div className="privacy">
      <div className="min-h-80vh px-4">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block"><div className="breadcrumbs"><Link to="/">Home</Link><span className="px-2">/</span><span>FAQs</span></div></div>
        <article className="cms-root_cmsFullWidth-5e3 cms-root-63a px-4"><div className="richContent-root-63a"><div className="row-contained-645 row-root-63a row-contained-inner"><div className="text-root-63a">
          <h1>Frequently Asked Questions</h1>
          {questions.map(([question, answer]) => <section key={question}><h2>{question}</h2><p className="p1">{answer}</p></section>)}
          <p className="p1">Still need help? Email <a href="mailto:level@failblossom.lifestyle">level@failblossom.lifestyle</a>.</p>
        </div></div></div></article>
      </div>
    </div>
  );
}

export default Faqs;
